import axios from "axios";

export default axios.create({
 // baseURL: process.env.REACT_APP_RENTCYCLEAPI_URL
 baseURL: '#{rentrackerapi}#'
});
